// 将 Schema.org JSON-LD 渲染进页面 DOM（不通过运行时 head 变更注入）。
export default function JsonLd({ data }: { data: object }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}